import { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import API from 'api/api';

export const useEmailVerification = () => {
  const { user, refreshUser } = useAuth();
  const [isEmailVerified, setIsEmailVerified] = useState(user ? user.emailVerified : false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user) {
      setIsEmailVerified(user.emailVerified);
    }
  }, [user]);

  const markEmailAsVerified = async () => {
    if (!user || isEmailVerified) return;

    setLoading(true);
    setError(null);
    try {
      // Refresh the user in AuthContext to reload it and get updated claims
      refreshUser();

      // Call your backend API to mark email as verified
      await API.patch(`/users/${user.uid}/verify-email`);
      setIsEmailVerified(true);
    } catch (err) {
      console.error("Error marking email as verified:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { isEmailVerified, loading, error, markEmailAsVerified };
};